module.exports = __webpack_public_path__ + "media/de.3e726c2b.svg";